var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import styles from './_sds-label-base.lit.scss';
const availableSizes = ['lg', 'md', 'sm'];
/**
 *  Label control that supports configurable variant and size
 */
let SdsLabelBase = (() => {
    var _a, _SdsLabelBase_name_accessor_storage, _SdsLabelBase_subtext_accessor_storage, _SdsLabelBase_role_accessor_storage, _SdsLabelBase_description_accessor_storage, _SdsLabelBase_icon_accessor_storage, _SdsLabelBase_src_accessor_storage, _SdsLabelBase_avatarIcon_accessor_storage, _SdsLabelBase_action_accessor_storage, _SdsLabelBase_selected_accessor_storage, _SdsLabelBase_focused_accessor_storage, _SdsLabelBase_selectable_accessor_storage, _SdsLabelBase_disabled_accessor_storage, _SdsLabelBase_identifier_accessor_storage;
    let _classSuper = LitElement;
    let _instanceExtraInitializers = [];
    let _name_decorators;
    let _name_initializers = [];
    let _name_extraInitializers = [];
    let _subtext_decorators;
    let _subtext_initializers = [];
    let _subtext_extraInitializers = [];
    let _role_decorators;
    let _role_initializers = [];
    let _role_extraInitializers = [];
    let _description_decorators;
    let _description_initializers = [];
    let _description_extraInitializers = [];
    let _icon_decorators;
    let _icon_initializers = [];
    let _icon_extraInitializers = [];
    let _src_decorators;
    let _src_initializers = [];
    let _src_extraInitializers = [];
    let _avatarIcon_decorators;
    let _avatarIcon_initializers = [];
    let _avatarIcon_extraInitializers = [];
    let _action_decorators;
    let _action_initializers = [];
    let _action_extraInitializers = [];
    let _selected_decorators;
    let _selected_initializers = [];
    let _selected_extraInitializers = [];
    let _focused_decorators;
    let _focused_initializers = [];
    let _focused_extraInitializers = [];
    let _selectable_decorators;
    let _selectable_initializers = [];
    let _selectable_extraInitializers = [];
    let _disabled_decorators;
    let _disabled_initializers = [];
    let _disabled_extraInitializers = [];
    let _identifier_decorators;
    let _identifier_initializers = [];
    let _identifier_extraInitializers = [];
    let _set_size_decorators;
    return _a = class SdsLabelBase extends _classSuper {
            /**
             * Name of this label
             * @attr
             */
            get name() { return __classPrivateFieldGet(this, _SdsLabelBase_name_accessor_storage, "f"); }
            set name(value) { __classPrivateFieldSet(this, _SdsLabelBase_name_accessor_storage, value, "f"); }
            /**
             * Subtext of this label
             * @attr
             */
            get subtext() { return __classPrivateFieldGet(this, _SdsLabelBase_subtext_accessor_storage, "f"); }
            set subtext(value) { __classPrivateFieldSet(this, _SdsLabelBase_subtext_accessor_storage, value, "f"); }
            /**
             * Role of this label
             * @attr
             */
            get role() { return __classPrivateFieldGet(this, _SdsLabelBase_role_accessor_storage, "f"); }
            set role(value) { __classPrivateFieldSet(this, _SdsLabelBase_role_accessor_storage, value, "f"); }
            /**
             * Description of this label
             * @attr
             */
            get description() { return __classPrivateFieldGet(this, _SdsLabelBase_description_accessor_storage, "f"); }
            set description(value) { __classPrivateFieldSet(this, _SdsLabelBase_description_accessor_storage, value, "f"); }
            /**
             * Label Icon
             * @attr
             */
            get icon() { return __classPrivateFieldGet(this, _SdsLabelBase_icon_accessor_storage, "f"); }
            set icon(value) { __classPrivateFieldSet(this, _SdsLabelBase_icon_accessor_storage, value, "f"); }
            /**
             * Label Avatar Source
             * @attr
             */
            get src() { return __classPrivateFieldGet(this, _SdsLabelBase_src_accessor_storage, "f"); }
            set src(value) { __classPrivateFieldSet(this, _SdsLabelBase_src_accessor_storage, value, "f"); }
            /**
             * Label Avatar Icon
             * @attr
             */
            get avatarIcon() { return __classPrivateFieldGet(this, _SdsLabelBase_avatarIcon_accessor_storage, "f"); }
            set avatarIcon(value) { __classPrivateFieldSet(this, _SdsLabelBase_avatarIcon_accessor_storage, value, "f"); }
            /**
             * If this attribute is true then label has an action
             * @attr
             */
            get action() { return __classPrivateFieldGet(this, _SdsLabelBase_action_accessor_storage, "f"); }
            set action(value) { __classPrivateFieldSet(this, _SdsLabelBase_action_accessor_storage, value, "f"); }
            /**
             * If this attribute is true then label is selected
             * @attr
             */
            get selected() { return __classPrivateFieldGet(this, _SdsLabelBase_selected_accessor_storage, "f"); }
            set selected(value) { __classPrivateFieldSet(this, _SdsLabelBase_selected_accessor_storage, value, "f"); }
            /**
             * If this attribute is true then label is focused
             * @attr
             */
            get focused() { return __classPrivateFieldGet(this, _SdsLabelBase_focused_accessor_storage, "f"); }
            set focused(value) { __classPrivateFieldSet(this, _SdsLabelBase_focused_accessor_storage, value, "f"); }
            /**
             * If this attribute is true then label is selectable
             * @attr
             */
            get selectable() { return __classPrivateFieldGet(this, _SdsLabelBase_selectable_accessor_storage, "f"); }
            set selectable(value) { __classPrivateFieldSet(this, _SdsLabelBase_selectable_accessor_storage, value, "f"); }
            /**
             * If this attribute is true then label is disabled
             * @attr
             */
            get disabled() { return __classPrivateFieldGet(this, _SdsLabelBase_disabled_accessor_storage, "f"); }
            set disabled(value) { __classPrivateFieldSet(this, _SdsLabelBase_disabled_accessor_storage, value, "f"); }
            /**
             * An optional identifier for the label.
             * This attribute can be used to uniquely identify the label in the context of its use.
             *
             * @attr {string|undefined} identifier - The identifier for the label.
             */
            get identifier() { return __classPrivateFieldGet(this, _SdsLabelBase_identifier_accessor_storage, "f"); }
            set identifier(value) { __classPrivateFieldSet(this, _SdsLabelBase_identifier_accessor_storage, value, "f"); }
            constructor() {
                super();
                _SdsLabelBase_name_accessor_storage.set(this, (__runInitializers(this, _instanceExtraInitializers), __runInitializers(this, _name_initializers, void 0)));
                _SdsLabelBase_subtext_accessor_storage.set(this, (__runInitializers(this, _name_extraInitializers), __runInitializers(this, _subtext_initializers, void 0)));
                _SdsLabelBase_role_accessor_storage.set(this, (__runInitializers(this, _subtext_extraInitializers), __runInitializers(this, _role_initializers, void 0)));
                _SdsLabelBase_description_accessor_storage.set(this, (__runInitializers(this, _role_extraInitializers), __runInitializers(this, _description_initializers, void 0)));
                _SdsLabelBase_icon_accessor_storage.set(this, (__runInitializers(this, _description_extraInitializers), __runInitializers(this, _icon_initializers, void 0)));
                _SdsLabelBase_src_accessor_storage.set(this, (__runInitializers(this, _icon_extraInitializers), __runInitializers(this, _src_initializers, void 0)));
                _SdsLabelBase_avatarIcon_accessor_storage.set(this, (__runInitializers(this, _src_extraInitializers), __runInitializers(this, _avatarIcon_initializers, void 0)));
                _SdsLabelBase_action_accessor_storage.set(this, (__runInitializers(this, _avatarIcon_extraInitializers), __runInitializers(this, _action_initializers, false)));
                _SdsLabelBase_selected_accessor_storage.set(this, (__runInitializers(this, _action_extraInitializers), __runInitializers(this, _selected_initializers, false)));
                _SdsLabelBase_focused_accessor_storage.set(this, (__runInitializers(this, _selected_extraInitializers), __runInitializers(this, _focused_initializers, false)));
                _SdsLabelBase_selectable_accessor_storage.set(this, (__runInitializers(this, _focused_extraInitializers), __runInitializers(this, _selectable_initializers, false)));
                _SdsLabelBase_disabled_accessor_storage.set(this, (__runInitializers(this, _selectable_extraInitializers), __runInitializers(this, _disabled_initializers, false)));
                _SdsLabelBase_identifier_accessor_storage.set(this, (__runInitializers(this, _disabled_extraInitializers), __runInitializers(this, _identifier_initializers, void 0)));
                /**
                 * Label size
                 * @attr
                 */
                this._size = (__runInitializers(this, _identifier_extraInitializers), 'lg');
                this.handleClose = (event) => {
                    this.dispatchEvent(new CustomEvent(_a.CLOSED_EVENT, {
                        detail: { name: this.name, identifier: this.identifier },
                        bubbles: false,
                        composed: false,
                    }));
                    event.stopPropagation();
                };
                this.disableClickWhenLabelIsDisabled();
            }
            get size() {
                return this._size;
            }
            set size(value) {
                const oldValue = this._size;
                this._size = value;
                this.requestUpdate('size', oldValue);
            }
            addEventListener(type, listener, options) {
                super.addEventListener(type, listener, options);
            }
            handleClick(event) {
                if (this.selectable) {
                    this.selected = !this.selected;
                }
                this.dispatchEvent(new CustomEvent(_a.LABEL_CLICK_EVENT, {
                    detail: { name: this.name, identifier: this.identifier },
                    bubbles: false,
                    composed: false,
                }));
                event === null || event === void 0 ? void 0 : event.stopPropagation();
            }
            getClasses() {
                return classMap({
                    'sds-label': true,
                    'sds-label--lg': this.size === 'lg',
                    'sds-label--md': this.size === 'md',
                    'sds-label--sm': this.size === 'sm',
                    'sds-label--disabled': this.disabled,
                    'sds-label--selected': this.selected,
                    'sds-label--focused': this.focused,
                    'sds-label--selectable': this.selectable,
                    'sds-label--action': this.action,
                    'sds-label--with-description': this.description,
                });
            }
            disableClickWhenLabelIsDisabled() {
                this.addEventListener(_a.CLICK_EVENT, event => {
                    if (this.disabled) {
                        event.stopImmediatePropagation();
                        event.preventDefault();
                        event.returnValue = false;
                    }
                }, true);
            }
        },
        _SdsLabelBase_name_accessor_storage = new WeakMap(),
        _SdsLabelBase_subtext_accessor_storage = new WeakMap(),
        _SdsLabelBase_role_accessor_storage = new WeakMap(),
        _SdsLabelBase_description_accessor_storage = new WeakMap(),
        _SdsLabelBase_icon_accessor_storage = new WeakMap(),
        _SdsLabelBase_src_accessor_storage = new WeakMap(),
        _SdsLabelBase_avatarIcon_accessor_storage = new WeakMap(),
        _SdsLabelBase_action_accessor_storage = new WeakMap(),
        _SdsLabelBase_selected_accessor_storage = new WeakMap(),
        _SdsLabelBase_focused_accessor_storage = new WeakMap(),
        _SdsLabelBase_selectable_accessor_storage = new WeakMap(),
        _SdsLabelBase_disabled_accessor_storage = new WeakMap(),
        _SdsLabelBase_identifier_accessor_storage = new WeakMap(),
        (() => {
            var _b;
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
            _name_decorators = [property({ type: String })];
            _subtext_decorators = [property({ type: String })];
            _role_decorators = [property({ type: String })];
            _description_decorators = [property({ type: String })];
            _icon_decorators = [property({ type: String })];
            _src_decorators = [property({ type: String })];
            _avatarIcon_decorators = [property({ type: String, attribute: 'avatar-icon' })];
            _action_decorators = [property({ type: Boolean })];
            _selected_decorators = [property({ type: Boolean })];
            _focused_decorators = [property({ type: Boolean })];
            _selectable_decorators = [property({ type: Boolean })];
            _disabled_decorators = [property({ type: Boolean })];
            _identifier_decorators = [property()];
            _set_size_decorators = [property({
                    type: String,
                    hasChanged: (newVal) => {
                        if (!availableSizes.includes(newVal)) {
                            console.error(`Unexpected Size ${newVal}`);
                            return false;
                        }
                        else {
                            return true;
                        }
                    },
                })];
            __esDecorate(_a, null, _name_decorators, { kind: "accessor", name: "name", static: false, private: false, access: { has: obj => "name" in obj, get: obj => obj.name, set: (obj, value) => { obj.name = value; } }, metadata: _metadata }, _name_initializers, _name_extraInitializers);
            __esDecorate(_a, null, _subtext_decorators, { kind: "accessor", name: "subtext", static: false, private: false, access: { has: obj => "subtext" in obj, get: obj => obj.subtext, set: (obj, value) => { obj.subtext = value; } }, metadata: _metadata }, _subtext_initializers, _subtext_extraInitializers);
            __esDecorate(_a, null, _role_decorators, { kind: "accessor", name: "role", static: false, private: false, access: { has: obj => "role" in obj, get: obj => obj.role, set: (obj, value) => { obj.role = value; } }, metadata: _metadata }, _role_initializers, _role_extraInitializers);
            __esDecorate(_a, null, _description_decorators, { kind: "accessor", name: "description", static: false, private: false, access: { has: obj => "description" in obj, get: obj => obj.description, set: (obj, value) => { obj.description = value; } }, metadata: _metadata }, _description_initializers, _description_extraInitializers);
            __esDecorate(_a, null, _icon_decorators, { kind: "accessor", name: "icon", static: false, private: false, access: { has: obj => "icon" in obj, get: obj => obj.icon, set: (obj, value) => { obj.icon = value; } }, metadata: _metadata }, _icon_initializers, _icon_extraInitializers);
            __esDecorate(_a, null, _src_decorators, { kind: "accessor", name: "src", static: false, private: false, access: { has: obj => "src" in obj, get: obj => obj.src, set: (obj, value) => { obj.src = value; } }, metadata: _metadata }, _src_initializers, _src_extraInitializers);
            __esDecorate(_a, null, _avatarIcon_decorators, { kind: "accessor", name: "avatarIcon", static: false, private: false, access: { has: obj => "avatarIcon" in obj, get: obj => obj.avatarIcon, set: (obj, value) => { obj.avatarIcon = value; } }, metadata: _metadata }, _avatarIcon_initializers, _avatarIcon_extraInitializers);
            __esDecorate(_a, null, _action_decorators, { kind: "accessor", name: "action", static: false, private: false, access: { has: obj => "action" in obj, get: obj => obj.action, set: (obj, value) => { obj.action = value; } }, metadata: _metadata }, _action_initializers, _action_extraInitializers);
            __esDecorate(_a, null, _selected_decorators, { kind: "accessor", name: "selected", static: false, private: false, access: { has: obj => "selected" in obj, get: obj => obj.selected, set: (obj, value) => { obj.selected = value; } }, metadata: _metadata }, _selected_initializers, _selected_extraInitializers);
            __esDecorate(_a, null, _focused_decorators, { kind: "accessor", name: "focused", static: false, private: false, access: { has: obj => "focused" in obj, get: obj => obj.focused, set: (obj, value) => { obj.focused = value; } }, metadata: _metadata }, _focused_initializers, _focused_extraInitializers);
            __esDecorate(_a, null, _selectable_decorators, { kind: "accessor", name: "selectable", static: false, private: false, access: { has: obj => "selectable" in obj, get: obj => obj.selectable, set: (obj, value) => { obj.selectable = value; } }, metadata: _metadata }, _selectable_initializers, _selectable_extraInitializers);
            __esDecorate(_a, null, _disabled_decorators, { kind: "accessor", name: "disabled", static: false, private: false, access: { has: obj => "disabled" in obj, get: obj => obj.disabled, set: (obj, value) => { obj.disabled = value; } }, metadata: _metadata }, _disabled_initializers, _disabled_extraInitializers);
            __esDecorate(_a, null, _identifier_decorators, { kind: "accessor", name: "identifier", static: false, private: false, access: { has: obj => "identifier" in obj, get: obj => obj.identifier, set: (obj, value) => { obj.identifier = value; } }, metadata: _metadata }, _identifier_initializers, _identifier_extraInitializers);
            __esDecorate(_a, null, _set_size_decorators, { kind: "setter", name: "size", static: false, private: false, access: { has: obj => "size" in obj, set: (obj, value) => { obj.size = value; } }, metadata: _metadata }, null, _instanceExtraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
        })(),
        _a.CLOSED_EVENT = 'sds.label.closed',
        _a.LABEL_CLICK_EVENT = 'sds.label.click',
        _a.CLICK_EVENT = 'click',
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        _a.styles = styles,
        _a;
})();
export { SdsLabelBase };
